<template>
  <BaseListHeader>
    <div class="flex -mx-4">
      <div class="flex-1 px-4">
        <span class="uppercase text-sm">number</span>
      </div>
    </div>
  </BaseListHeader>
</template>

<script>
export default {
  name: 'ListingHeader',
};
</script>
